const Data = [
  {
    name: "Arpan Mondal",
    position: "Rise Head",
    imageUrl: "/images/profile.png",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  },
  {
    name: "Rishika Bhimrajka",
    position: "Rise Head",
    imageUrl: "/assets/images/members/Heads25/RishikaBhimrajka.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  },
  {
    name: "Kattayani Sanyal",
    position: "Rise Head",
    imageUrl: "/images/profile.png",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;